import { createContext } from "react";
import type { BoardConfiguration } from "../types/jben/board_configuration";

export const BoardConfigurationContext = createContext<BoardConfiguration | null>(null);
